module.exports = __webpack_public_path__ + "img/MKR.56d7ac57.svg";